import * as React from 'react';
// import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
export default function LeftSection() {
  return (
    // <Grid item xs={0} sm={0} md={6} sx={styles.photoSectionStyle}>
    <Box component="img" src={require('../images/HeartPhoto_Marcela.png')} sx={styles.photoStyle} />
    // </Grid>
  );
}
const styles = {
  photoStyle: {
    border: 0,
    // width: '100%',
    height: '100%',
    ['@media (max-width:768px)']: {
      width: '100%'
    }
    // height: '86vh'
    // borderBottomLeftRadius: 15,
    // borderBottomRightRadius: 100,
    // borderTopRightRadius: 100,
    // borderTopLeftRadius: 15
    // overflow: 'hidden'
  },
  photoSectionStyle: {
    backgroundColor: '#EDF3FC'
  }
};
